
export function mapRoutesSvToEn(route: string) {
    return route
        .replaceAll('yrkesomraden', 'areas')
        .replaceAll('yrkesomrade', 'job_area')
        .replaceAll('yrkeskategorier', 'groups')
        .replaceAll('yrkeskategori', 'job_group')
        .replaceAll('yrkesgrupper', 'groups')
        .replaceAll('yrkesgrupp', 'job_group')
        .replaceAll('yrken', 'jobs')
        .replaceAll('yrke', 'job')
        .replaceAll('regioner', 'regions')
        .replaceAll('kompetenser', 'skills')
        .replaceAll('egenskaper', 'traits')
        .replaceAll('arbetsgivare', 'companies')
}
export function mapRoutesEnToSv(route: string) {
    return route
        .replaceAll('areas', 'yrkesomraden')
        .replaceAll('job_area', 'yrkesomrade')
        .replaceAll('groups', 'yrkeskategorier')
        .replaceAll('job_group', 'yrkeskategori')
        .replaceAll('jobs', 'yrken')
        .replaceAll('job', 'yrke')
        .replaceAll('regions', 'regioner')
        .replaceAll('skills', 'kompetenser')
        .replaceAll('traits', 'egenskaper')
        .replaceAll('companies', 'arbetsgivare')
}